(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('UserContactinfoType', [UserContactinfoTypeFn]);

    /*
     * contact info type object
     * No Constants because in future there could be more types (facebook fe)
     */
    function UserContactinfoTypeFn() {
        var UserContactinfoType = function () {

            // vm variablen
            this.icon = null;
            this.inputType = 'text'; //defaut

            // functions
            this.extend = extend;

            /* set the right icon to show */
            function setIcon(self) {
                switch (self.type) {
                    case 1: //phone
                        self.icon = 'phone';
                        break;
                    case 2: //mobile
                        self.icon = 'mobile';
                        break;
                    case 3: //email
                        self.icon = 'envelope-o';
                        break;
                    case 4: //fax
                        self.icon = 'fax';
                        break;
                    case 5: //website
                        self.icon = 'globe';
                        break;
                    default:
                        self.icon = '';
                        break;

                }
            }

            /* set the right input text type */

            // setting input type enables automatic validation -> don't forget to display errormessage
            function setInputType(self) {
                if (self.type === 3) { //email
                    self.inputType = 'email';
                }
            }


            /* init task -> extend object */
            function extend(type) {
                var self = this;
                angular.extend(self, type);

                // set icon
                setIcon(self);
                // set input type
                setInputType(self);
            }            
        };

        return UserContactinfoType;

    }
})();